import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Club_PageMenu_ApiEnum } from './ClubDetailConfigApiInterface';

export enum Config_ClubCompetitions_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_ClubCompetitions_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'players' = 'players',
}

export enum Config_ClubCompetitions_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_ClubCompetitions_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_ClubCompetitions_ApiInterface
    extends ConfigDataInterface<
        Config_ClubCompetitions_Modules_ApiEnum,
        Config_ClubCompetitions_ActionsMenu_ApiEnum,
        Config_ClubCompetitions_ActionsOther_ApiEnum,
        Config_Club_PageMenu_ApiEnum,
        Config_ClubCompetitions_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
